import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type CompilationStatus = 'idle' | 'compiling' | 'completed' | 'timeout';

interface ParamCompilationState {
  status: CompilationStatus;
  startCompilation: () => void;
  compilationCompleted: () => void;
  compilationTimedOut: () => void;
  dismiss: () => void;
}

export const useParamCompilationStore = create<ParamCompilationState>()(
  devtools(set => ({
    status: 'idle',
    startCompilation: () => set({ status: 'compiling' }),
    compilationCompleted: () => set({ status: 'completed' }),
    compilationTimedOut: () => set({ status: 'timeout' }),
    dismiss: () => set({ status: 'idle' }),
  }))
);
